import { Navigate, useSearchParams } from 'react-router-dom';

import { useOrgSlug } from '@/hooks/use-org-slug';
import { PUBLIC_ROUTES, STORE_ROUTES } from '@/config/router';

/**
 * Landing route for the Whop Platforms KYC callback. The API callback can't know the org slug
 * (Clerk, resolved in the CRM), so it redirects here; we resolve the active org and forward to the
 * org-scoped integrations page, preserving the query params. Mirrors SetupPaymentRedirect.
 */
export function WhopReturnRedirect() {
  const [sp] = useSearchParams();
  const { activeOrgSlug, isLoaded } = useOrgSlug();

  const storeId = sp.get('storeId');
  if (!storeId) return <Navigate to="/" replace />;
  if (!isLoaded) return null;
  if (!activeOrgSlug) return <Navigate to={PUBLIC_ROUTES.NO_ORGANIZATION} replace />;

  const forwarded = new URLSearchParams(sp);
  forwarded.delete('storeId');
  const qs = forwarded.toString();

  const target = `${STORE_ROUTES(activeOrgSlug, storeId).INTEGRATIONS()}${qs ? `?${qs}` : ''}`;
  return <Navigate to={target} replace />;
}
